import cm from 'classnames';
import { Loader } from 'components/UI/loader/loader';
import styles from '../_input.module.scss';

interface Props {
  title: string;
  value: boolean;
  setValue: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export const InputCheck = ({ value, setValue, title, loading, disabled, className }: Props) => {
  const onClick = () => {
    if (disabled || loading) return;
    setValue();
  };

  return (
    <div
      className={cm(styles.InputCheck, className, {
        [styles['InputCheck--active']]: value,
        [styles['InputCheck--loading']]: loading,
        [styles['InputCheck--disabled']]: disabled,
      })}
      onClick={onClick}
    >
      <div className={styles.InputCheck__handler}>
        <Loader className={styles.InputCheck__loader} />
        <span></span>
      </div>
      <span>{title}</span>
    </div>
  );
};
